import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import SignInModal from "./SignInModal";

const SignInModalContext = createContext(null);

export function SignInModalProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openSignIn = useCallback(() => setOpen(true), []);
  const closeSignIn = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ openSignIn, closeSignIn, isOpen: open }),
    [open, openSignIn, closeSignIn]
  );

  return (
    <SignInModalContext.Provider value={value}>
      {children}
      <SignInModal open={open} onClose={closeSignIn} />
    </SignInModalContext.Provider>
  );
}

export function useSignInModal() {
  const context = useContext(SignInModalContext);
  if (!context) {
    throw new Error("useSignInModal must be used within SignInModalProvider");
  }
  return context;
}
